export default __webpack_public_path__ + "static/media/section1-bg8.d343c903.png";